module.exports = __webpack_public_path__ + "img/five_sec_countdown.4355782.gif";